import React, { useEffect, useState } from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import "../css/Campaign.css";
import Faq from "../Common/Faq";


function Campaign() {
 
  return (
    <div>
      <Header />

      {/* above campaign container */}
      <div className="campaign-above-container">
        <div className="common-container">
          <div className="campaign-above-left">
            <h2>Launch, Automate, and Manage Campaigns Like a Pro</h2>
            <p>
              Design and schedule powerful campaigns, build smart workflows, and
              automate your entire customer journey — all from one seamless
              platform.
            </p>

            <p className="campaign-above-below-para">
              Manage and track all your marketing campaigns from one centralized
              platform. Plan targeted campaigns based on leads, contacts, or
              customer segments, and automate follow-ups using smart workflows.
              Monitor performance in real time with detailed analytics and
              engagement insights.
            </p>
            <button className="campaign-above-btn">Start Now</button>
          </div>
          <div className="campaign-above-right">
            <img src="./images/campaign.png" alt="campaign" />
          </div>
        </div>
      </div>

      {/* create campaign container */}
      <div className="create-campaign-container">
        <div className="common-container">
          <div className="campaign-layout">
            <h2 className="campaign-title">Create Campaign with Confidence</h2>
            <div className="campaign-first-section">
              <img
                src="./images/create-campaign.png"
                alt="Create Campaign"
                className="campaign-image"
              />

              <div className="campaign-text-block">
                <h3 className="campaign-subtitle">Create Campaign</h3>
                <p className="campaign-description">
                  Easily create and schedule campaigns tailored to your goals.
                  Whether you're planning a one-time blast or a recurring
                  outreach, our intuitive interface lets you define your
                  audience, choose your channels, and set the perfect time to
                  launch. With real-time previews, flexible scheduling, and
                  smart segmentation, building impactful campaigns has never
                  been this effortless.
                </p>
              </div>
            </div>

            <div className="campaign-second-section">
              <div className="campaign-text-block">
                <h3 className="campaign-subtitle">Schedule Campaign</h3>
                <p className="campaign-description">
                  Take full control of your timing with advanced scheduling
                  options. Plan campaigns to run at the right moment — whether
                  it's immediately, on a future date, or in a recurring cycle.
                  Set it once and let the system handle the rest, ensuring your
                  message reaches the audience when it matters most. Stay
                  consistent, save time, and never miss a deadline.
                </p>
              </div>

              <img
                src="./images/schedule-campaign.png"
                alt="Schedule Campaign"
                className="campaign-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* workflow campaign container */}
      <div className="workflow-campaign-container">
        <div className="common-container">
          <div className="workflow-layout">
            <div className="campaign-first-section">
              <img
                src="./images/custom-workflow.png"
                alt="Create Campaign"
                className="campaign-image"
              />

              <div className="campaign-text-block">
                <h3 className="campaign-subtitle">
                  Custom Workflows, Built Your Way
                </h3>
                <p className="campaign-description">
                  Automate your entire customer journey with intelligent,
                  customizable workflows tailored to your business needs.
                  Whether you're starting from scratch or using a pre-built
                  scheduled template, you can easily create workflows that
                  respond to specific actions related to contacts, companies,
                  deals, tickets, or quotes.
                </p>
              </div>
            </div>

            <div className="campaign-second-section">
              <div className="campaign-text-block">
                <h3 className="campaign-subtitle">Setup Custom Triggers</h3>
                <p className="campaign-description">
                  Set up powerful triggers, define multi-step actions, and watch
                  as your system takes over repetitive tasks — sending emails,
                  updating data, assigning team members, and more. Save hours of
                  manual effort and keep your marketing, sales, and support
                  campaigns running smoothly and intelligently at all times.
                </p>
              </div>

              <img
                src="./images/custom-trigger.png"
                alt="Schedule Campaign"
                className="campaign-image"
              />
            </div>
          </div>
        </div>
      </div>
      <Faq
        endpoint="/api/faq/GetFaqList" // only endpoint, domain comes from .env
        params={{
          currentPage: 1,
          pageSize: 20,
          sortColumn: "FaqId",
          sortDirection: "asc",
          category: "Others"
        }}
      />
      <Footer />
    </div>
  );
}

export default Campaign;
